// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApiRest: 'http://localhost:8999/',
  urlApiLmpRest: 'https://api.lmp.mx/3.0.0/',
  urlPlayer: 'http://localhost:8100/',
  openpayId: 'm2s3ev8iubzcfgcuvuh0',
  openpayPK: 'pk_0f59b4ea3e91462e91700e05b68bc76b',
  openpaySK: 'sk_6de7a3b363c742f798cc1c9d30eeb5e4',
  openpayAction: 'https://sandbox-dashboard.openpay.mx/',
  openpaySandboxMode: true,
  paypalAction: 'https://sandbox.paypal.com/cgi-bin/webscr',
  paypalAccount: 'jmartinzayasz-facilitator@gmail.com',
  paypalAccountOtherCountries: 'jmartinzayasz-facilitator@gmail.com', //cuenta de paypal para hacer pagos fuera de méxico
  urlApiCalendar: 'https://api.lmp.mx/3.0.0/',
  language:['es','en']
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
